import httpClient from "./httpClient";

const DashboardService = {
  async getStats() {
    return await httpClient.get("/dashboard/stats");
  },

  async getConnectivity() {
    return await httpClient.get("/dashboard/connectivity");
  },

  async testPush() {
    return await httpClient.post("/dashboard/test-push");
  }
};

export default DashboardService;
